import { useRef, useCallback } from 'react';
import { View } from 'react-native';
import { useManageFavoriteButton } from '@components/common/favoriteButton/hooks/useManageFavoriteButton';

interface UseManageAttachItemGlassParams {
  scopeId: number;
  scopeReferenceId: number;
  onAttachButtonPress?: () => void;
  onFavoriteIconPress?: () => void;
  contextKey?: string | null;
}

export const useManageAttachItemGlass = ({
  scopeId,
  scopeReferenceId,
  onAttachButtonPress,
  onFavoriteIconPress,
  contextKey,
}: UseManageAttachItemGlassParams) => {
  const { onButtonPress: onAttachButtonPressDefault, isFavorite } = useManageFavoriteButton({ scopeId, scopeReferenceId, contextKey });
  const favoriteRef = useRef<View>(null);
  const clickLocationRef = useRef<{ x: number; y: number } | null>(null);

  const handleGlassButtonPress = useCallback((event?: any) => {

    // Store click location
    if (event?.nativeEvent) {
      clickLocationRef.current = {
        x: event.nativeEvent.pageX || event.nativeEvent.locationX,
        y: event.nativeEvent.pageY || event.nativeEvent.locationY
      };
    }

    // Check if click is within the favorite icon bounds
    if (favoriteRef.current && onFavoriteIconPress) {
      favoriteRef.current.measure((_fx, _fy, width, height, px, py) => {
        if (clickLocationRef.current) {
          const clickX = clickLocationRef.current.x;
          const clickY = clickLocationRef.current.y;

          // Check if click is within favorite icon bounds with buffer zone
          // Add 20px horizontal buffer (10px each side) and 15px vertical buffer (7.5px each side)
          const horizontalBuffer = 20;
          const verticalBuffer = 15;

          if (clickX >= px - horizontalBuffer/2 &&
              clickX <= px + width + horizontalBuffer/2 &&
              clickY >= py - verticalBuffer/2 &&
              clickY <= py + height + verticalBuffer/2) {
            onFavoriteIconPress();
            return;
          }
        }

        // Regular button click
        if (onAttachButtonPress) {
          onAttachButtonPress();
        } else {
          onAttachButtonPressDefault();
        }
      });
    } else {

      // Regular button click
      if (onAttachButtonPress) {
        onAttachButtonPress();
      } else {
        onAttachButtonPressDefault();
      }
    }
  }, [onFavoriteIconPress, onAttachButtonPress, onAttachButtonPressDefault]);

  return {
    handleGlassButtonPress,
    favoriteRef,
    isFavorite,
  };
};